import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../../context/AuthContext";
import { Lock, LogIn } from "lucide-react";
import { COMPANY } from "../../lib/siteData";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-10">
          <img src={COMPANY.logos.transparent} alt={COMPANY.name} className="h-16 w-auto brightness-0 invert opacity-90" />
        </div>
        <div className="bg-white text-ink p-8 lg:p-10 border-t-4 border-brand">
          <div className="overline mb-4">Admin Access</div>
          <h1 className="font-heading font-extrabold text-2xl text-ink mb-2 flex items-center gap-3">
            <Lock className="w-6 h-6 text-brand" strokeWidth={1.5} />
            Sign in
          </h1>
          <p className="text-sm text-ink-muted mb-8">Internal dashboard — access restricted to authorized administrators.</p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-soft mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-login-email"
                className="w-full bg-white border border-steel-300 px-4 py-3 text-sm focus:border-brand focus:outline-none"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-soft mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-login-password"
                className="w-full bg-white border border-steel-300 px-4 py-3 text-sm focus:border-brand focus:outline-none"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div className="bg-brand-tint border-l-4 border-brand text-brand-deep px-4 py-3 text-sm" data-testid="admin-login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover disabled:opacity-60 text-white px-6 py-4 font-semibold text-sm uppercase tracking-[0.18em] transition-colors"
            >
              {submitting ? "Signing in…" : "Sign in"} <LogIn className="w-4 h-4" />
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-steel-500 mt-6 font-mono uppercase tracking-[0.2em]">
          Waves Technology FZCO · Admin
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
